// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__QzJ7S","content":"ManualTimeModal_content__2axJ7"};